import { useEffect } from 'react';

const StructuredData = () => {
  useEffect(() => {
    // Local Business Schema
    const localBusinessSchema = {
      "@context": "https://schema.org",
      "@type": "MarketingAgency",
      "name": "Arikone",
      "image": window.location.origin + "/logo.png",
      "description": "Leading digital marketing agency offering brand promotion, social media marketing, performance ads, website development, and lead generation services.",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Jagriti palace, opp. Bikanerwala, Noida Sector 18, Atta Market, Pocket E, Sector 27",
        "addressLocality": "Noida",
        "addressRegion": "Uttar Pradesh",
        "postalCode": "201301",
        "addressCountry": "IN"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": "28.572417",
        "longitude": "77.324150"
      },
      "telephone": "+91-96955-35755",
      "openingHours": "Mo-Sa 09:00-19:00",
      "priceRange": "$$",
      "url": "https://www.arikone.com",
      "sameAs": [
        "https://www.facebook.com/arikone",
        "https://www.instagram.com/arikone",
        "https://www.linkedin.com/company/arikone"
      ],
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "5.0",
        "reviewCount": "19"
      },
      "areaServed": [
        {
          "@type": "City",
          "name": "Noida"
        },
        {
          "@type": "City",
          "name": "Delhi"
        },
        {
          "@type": "State",
          "name": "Delhi NCR"
        }
      ],
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Digital Marketing Services",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Digital Marketing",
              "description": "Comprehensive digital strategies to boost your online presence"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Social Media Marketing",
              "description": "Engage your audience across all platforms"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Performance Ads",
              "description": "Data-driven advertising campaigns"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Website Development",
              "description": "Modern, responsive websites"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Branding & Creative Design",
              "description": "Create memorable brand identities"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Lead Generation",
              "description": "Strategic campaigns to attract quality leads"
            }
          }
        ]
      }
    };

    // Organization Schema
    const organizationSchema = {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "Arikone",
      "alternateName": "Arikone Digital Marketing Agency",
      "url": "https://www.arikone.com",
      "image": window.location.origin + "/logo.png",
      "slogan": "Business Apka Saath Hamara",
      "sameAs": [
        "https://www.instagram.com/arikone.agency",
        "https://www.linkedin.com/company/arikone",
        "https://www.facebook.com/arikone"
      ],
      "contactPoint": {
        "@type": "ContactPoint",
        "telephone": "+91-96955-35755",
        "contactType": "Customer Service",
        "areaServed": "IN",
        "availableLanguage": ["English", "Hindi"]
      }
    };

    // Breadcrumb Schema
    const breadcrumbSchema = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": window.location.origin
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": window.location.pathname.replace('/', '') || "Home",
          "item": window.location.href
        }
      ]
    };

    // Create script tags
    const addSchema = (schema, id) => {
      let script = document.getElementById(id);
      if (!script) {
        script = document.createElement('script');
        script.id = id;
        script.type = 'application/ld+json';
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(schema);
    };

    addSchema(localBusinessSchema, 'local-business-schema');
    addSchema(organizationSchema, 'organization-schema');
    addSchema(breadcrumbSchema, 'breadcrumb-schema');

  }, []);

  return null;
};

export default StructuredData;
